const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

const getAuthToken = (): string | null => {
    return localStorage.getItem('token');
};

export const whatsappApi = {
    getStatus: async (salonId: string) => {
        const token = getAuthToken();
        const response = await fetch(`${API_URL}/whatsapp/status?salonId=${salonId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error('Failed to get status');
        return response.json();
    },

    connect: async (salonId: string) => {
        const token = getAuthToken();
        const response = await fetch(`${API_URL}/whatsapp/connect?salonId=${salonId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error('Failed to connect');
        return response.json();
    }
};
